export default {
  SET_CLIENT(state, client) {
    state.client = client;
  },
  SET_CLIENT_FBS(state, fbs) {
    state.client = { ...state.client, ...fbs };
  },
  SET_CLIENT_CAMERAS(state, cameras) {
    state.cameras = cameras;
  },
  SET_CLIENT_SHARED_CAMERAS(state, sharedCameras) {
    state.sharedCameras = sharedCameras;
  },
  SET_CLIENT_INTERCOMS(state, intercoms) {
    state.intercoms = intercoms;
  },
  SET_OPERATOR_PARAMETERS(state, payload) {
    state.operatorParameters = payload;
  },
};
